<ion-header>
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button (click)="cancel()" (keydown.enter)="cancel()">
                <ion-icon
                    slot="icon-only"
                    name="close"
                    color="medium"
                ></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{
            "changeTelemetryUnitPinModal.title" | translate
        }}</ion-title>
    </ion-toolbar>
</ion-header>
<div class="pin-modal-body ion-padding">
    <ion-list>
        <ion-item lines="none">
            <ion-note>
                {{ "changeTelemetryUnitPinModal.description1" | translate }}
                <br />{{
                    "changeTelemetryUnitPinModal.description2" | translate
                }} ({{ telemetryUnitId() }})
            </ion-note>
        </ion-item>
        <ion-item lines="none">
            <div class="input-wrapper">
                <ion-input
                    labelPlacement="stacked"
                    [label]="
                        'changeTelemetryUnitPinModal.currentPin' | translate
                    "
                    type="password"
                    inputmode="numeric"
                    [formField]="pinForm.oldPin"
                    [placeholder]="
                        'changeTelemetryUnitPinModal.currentPinPlaceholder'
                            | translate
                    "
                    [errorText]="
                        'changeTelemetryUnitPinModal.currentPinError'
                            | translate
                    "
                    clearInput="true"
                >
                </ion-input>
                @if (pinForm.oldPin().touched() && pinForm.oldPin().invalid()) {
                    <ul class="error-list">
                        @for (
                            error of pinForm.oldPin().errors();
                            track error.message
                        ) {
                            <li>
                                {{ error.message | translate }}
                            </li>
                        }
                    </ul>
                }
            </div>
        </ion-item>
        <ion-item lines="none">
            <div class="input-wrapper">
                <ion-input
                    labelPlacement="stacked"
                    [label]="'changeTelemetryUnitPinModal.newPin' | translate"
                    type="password"
                    inputmode="numeric"
                    [formField]="pinForm.newPin"
                    [placeholder]="
                        'changeTelemetryUnitPinModal.newPinPlaceholder'
                            | translate
                    "
                    [errorText]="
                        'changeTelemetryUnitPinModal.newPinError' | translate
                    "
                    clearInput="true"
                    [class.ion-touched]="pinForm.newPin().touched()"
                    [class.ion-invalid]="pinForm.newPin().invalid()"
                >
                </ion-input>
                @if (pinForm.newPin().touched() && pinForm.newPin().invalid()) {
                    <ul class="error-list">
                        @for (
                            error of pinForm.newPin().errors();
                            track error.message
                        ) {
                            <li>
                                {{ error.message | translate }}
                            </li>
                        }
                    </ul>
                }
            </div>
        </ion-item>
        <ion-item lines="none">
            <div class="input-wrapper">
                <ion-input
                    labelPlacement="stacked"
                    [label]="
                        'changeTelemetryUnitPinModal.confirmNewPin' | translate
                    "
                    type="password"
                    inputmode="numeric"
                    [formField]="pinForm.confirmNewPin"
                    [placeholder]="
                        'changeTelemetryUnitPinModal.confirmNewPinPlaceholder'
                            | translate
                    "
                    [errorText]="
                        'changeTelemetryUnitPinModal.confirmNewPinError'
                            | translate
                    "
                    clearInput="true"
                    (keydown.enter)="onSubmit()"
                >
                </ion-input>
                @if (
                    pinForm.confirmNewPin().touched() &&
                    pinForm.confirmNewPin().invalid()
                ) {
                    <ul class="error-list">
                        @for (
                            error of pinForm.confirmNewPin().errors();
                            track error.message
                        ) {
                            <li>
                                {{ error.message | translate }}
                            </li>
                        }
                    </ul>
                }
            </div>
        </ion-item>
    </ion-list>
    <ion-button
        expand="block"
        class="ion-margin-top"
        [disabled]="isSubmitDisabled()"
        (click)="onSubmit()"
        (keydown.enter)="onSubmit()"
    >
        {{ "changeTelemetryUnitPinModal.savePin" | translate }}
    </ion-button>
</div>
